const AgendaData25 = [
  // Sunday
  // Sunday
  // Sunday
  // Sunday
  // Sunday
  {
    title: "Sunday, Sept 7",
    events: [
      {
        time: "3:00 pm - 7:00 pm",
        title: "FinComp Registration",
      },
    ],
  },
  // Monday
  // Monday
  // Monday
  // Monday
  // Monday
  {
    title: "Monday, Sept 8",
    events: [
      {
        time: "7:30 am - 8:30 am",
        title: "Breakfast & Registration",
      },
      {
        time: "8:30 am - 10:00 am",
        title: "Radical Humility: Be a Badass Leader and a Good Human",
        isKeynote: true,
        sessions: [
          {
            speakers: [
              {
                name: "Urs Koenig",
                // company: "N/A",
              },
            ],
            description:
              "With the world changing faster than ever before, increasing business competition, rapid technological change, and an incredibly diverse generation entering the workforce, a new, elevated style of leadership is required. This modern form of leadership is called leading with Radical Humility; a more human-centered approach that views humility as a key strength to achieving goals in today's complex world.</p> <p>Radical Humility unlocks exactly how to deliver stellar business results with teams looking to mitigate burnout, overwhelm, exhaustion, resistance, and high turnover while promoting productivity, engagement, innovation, and creativity.",
          },
        ],
      },
      {
        time: "10:00 am - 10:15 am",
        title: "Morning Break",
      },
      {
        time: "10:15 am - 11:45 am",
        title:
          "Cents and Sensibility: Compensation Trends You Can’t Afford to Ignore",
        sessions: [
          {
            speakers: [
              {
                name: "Christie Summervill",
                company: "BalancedComp",
              },
            ],
            description:
              "HR leaders will explore the latest shifts in pay strategies that are quietly revolutionizing the banking world—whether you're ready or not. We’ll break down how to stay competitive without breaking the budget (or your CFO’s heart). Expect practical insights on aligning pay with performance, keeping regulators happy, and yes, finally answering that eternal question: “Are we paying enough… or just enough to lose them slowly?” You’ll leave armed with data, strategies, and just enough sass to defend your next comp plan with a straight face and a strong case.",
          },
        ],
      },
      {
        time: "11:45 am - 1:30 pm",
        title: "Lunch",
      },
      {
        time: "1:30 pm - 2:30 pm",
        sessions: [
          {
            count: "1",
            title: "The ROI of Competitive Compensation",

            speakers: [
              {
                name: "Rachel Prine",
                company: "BalancedComp",
              },
            ],

            description:
              "Are you ever frustrated by a lower-than-market labor budget? During this presentation, attendees will be trained to articulate and demonstrate the incredible impact a market-competitive budget has on financials.<hr class='my-4'>",
          },
          {
            count: "2",
            title:
              "How to Nail Compensation Plans Without Blowing Up Your Talent Strategy",

            speakers: [
              {
                name: "Flynt Gallagher",
                company: "Newcleus",
              },
            ],
            description:
              "In an era where top talent can be gone with one LinkedIn message, getting compensation right isn't a nice-to-have—it's survival. This session pulls no punches. We’ll show you how to surgically decide who’s worth the extra dollars, when to open the vault, and where to draw the line before your “smart rewards” backfire. From non-qualified plans to synthetic equity, you’ll learn how to weaponize comp strategy to attract, retain, and reward your most critical players—without stepping on the landmines that can quietly sabotage your leadership pipeline. Real examples. Tough truths. Zero fluff.<hr class='my-4'>",
          },
          {
            count: "3",
            title: "How to Talk Comp With Different Types of People",

            speakers: [
              {
                name: "Dolly Penland",
                company: "Business Results",
              },
            ],
            description:
              "Every person responds to compensation conversations differently. The best way to talk comp is to know who you are talking to!",
          },
        ],
      },
      {
        time: "2:30 pm - 2:45 pm",
        title: "Afternoon Break",
      },
      {
        time: "2:45 pm - 4:15 pm",
        title: "HR Roundtables",
        sessions: [
          {
            speakers: [
              {
                name: "Christie Summervill",
                company: "BalancedComp",
              },
              {
                name: "Debbie Reid",
                company: "BalancedComp",
              },
              {
                name: "Dolly Penland",
                company: "Business Results",
              },
              {
                name: "JR Llewellyn",
                company: "Newcleus",
              },
            ],
          },
        ],
      },
      {
        time: "4:30 pm - 6:30 pm",
        title: "Networking Mixer",
      },
    ],
  },

  // Tuesday
  // Tuesday
  // Tuesday
  // Tuesday
  // Tuesday
  {
    title: "Tuesday, Sept 9",
    events: [
      {
        time: "7:30 am - 8:30 am",
        title: "Breakfast & Registration",
      },
      {
        time: "8:30 am - 10:00 am",
        title: "Hope is a Verb",
        isKeynote: true,
        sessions: [
          {
            speakers: [
              {
                name: "Amy Downs",
                company: "Allegiance Credit Union",
              },
            ],
            description:
              "Amy Downs survived a bomb exploding in the building of the credit union where she was working, which killed 168 people, including 18 of her 33 co-workers. Today, she is President and an award-winning CEO of that same organization. Allegiance Credit Union has grown by 400% and is thriving. Drawing on her recently released book Hope Is A Verb, Amy is excited to share how you can respond to a crisis in a way that will make your organization come out of this even stronger than before you went in. Following her keynote, Amy will be available for a brief meet and greet, and attendees will be invited to participate in small-group conversations—guided by prompts inspired by Amy’s story and book—to reflect, connect, and go deeper.",
          },
        ],
      },
      {
        time: "10:00 am - 10:15 am",
        title: "Morning Break",
      },
      {
        time: "10:15 am - 11:45 am",
        title:
          "My Compa-Ratio is Better Than Yours - Navigating Compensation Discussions",
        sessions: [
          {
            speakers: [
              {
                name: "Virginia Whitham",
                company: "Rally Credit Union",
              },
            ],

            description:
              "This presentation will provide strategic insights and practical approaches to fostering transparent, equitable, and compliant compensation conversations while maintaining trust and engagement at all levels of the organization. We will explore best practices for addressing employee concerns about pay levels, guiding managers in performance-based salary discussions, and effectively educating and addressing executive compensation structures to the board. Attendees will learn how to leverage data-driven decision-making, provide empathetic communication and regulatory alignment, and turn compensation discussions into opportunities for strengthening company culture, driving performance, and enhancing retention.",
          },
        ],
      },
      {
        time: "11:45 am - 1:30 pm",
        title: "Lunch",
      },
      {
        time: "1:30 pm - 2:30 pm",
        sessions: [
          {
            count: "1",
            title:
              "The Hidden Cost of Inaction: Stop Leaving Money and Talent on the Table",

            speakers: [
              {
                name: "Deborah E. Arndell",
                company: "ARMOR Advisory Services",
              },
            ],

            description:
              "A counterintuitive, cyclical (and lovely snowballing) process designed to increase revenue, improve efficiency, improve effectiveness, decrease stress, and drive your business into a slimmed-down, ramped-up version of its current self. How to do a lot more with a lot less, freeing up time to (1) better absorb and integrate change in the present and (2) focus on future growth and development.<hr class='my-4'>",
          },
          {
            count: "2",
            title: "Want to become a Certified Total Rewards Leader?",

            speakers: [
              {
                name: "L. Marta Turba",
                company: "WorldatWork",
              },
            ],

            description:
              "Total Rewards isn’t just about pay and perks—it’s the secret weapon for driving business success! In this interactive session, we’ll explore how CHROs can elevate their strategic impact by building Total Rewards capabilities. From aligning rewards with business goals to mastering data-driven decision-making and pay equity, we’ll cover the must-have skills for future-ready HR leaders. Plus, get a sneak peek at WorldatWork’s new Total Rewards Leadership Certification and other learning pathways designed to fast-track rewards expertise—from foundational knowledge to deep-dive immersion and expert-level mastery. Let’s move beyond transactions and transform Total Rewards into a powerhouse for talent strategy.<hr class='my-4'>",
          },
          {
            count: "3",
            title:
              "US Economic Outlook and its Impact on Financial Institutions",

            speakers: [
              {
                name: "Steven Rick",
                company: "TruStage",
              },
            ],
            description:
              "The presentation will discuss how the global economy, the overall financial sector and the labor market will affect the U.S. economy, U.S. interest rates and ultimately credit union balance sheet and earnings performance. Steve Rick will analyze and establish standards against which your credit union’s own performance can be measured. Mr. Rick will also identify trends of savings and loan activity, and weigh the influence of future economic events on growth patterns out into 2026.",
          },
        ],
      },
      {
        time: "2:30 pm - 2:45 pm",
        title: "Afternoon Break",
      },
      {
        time: "2:45 pm - 4:15 pm",
        title: "HR Roundtables",
        sessions: [
          {
            speakers: [
              {
                name: "Christie Summervill",
                company: "BalancedComp",
              },
              {
                name: "Debbie Reid",
                company: "BalancedComp",
              },
              {
                name: "Philippe Asselin",
                company: "BalancedComp",
              },
              {
                name: "Rachel Prine",
                company: "BalancedComp",
              },
            ],
          },
        ],
      },
    ],
  },

  // Wednesday
  // Wednesday
  // Wednesday
  // Wednesday
  // Wednesday
  {
    title: "Wednesday, Sept 10",
    events: [
      {
        time: "7:30 am - 8:30 am",
        title: "Breakfast & Registration",
      },
      {
        time: "8:30 am - 10:00 am",
        title:
          "First, Do No Harm: The Unintended Consequences of Everyday Compensation Decisions",
        sessions: [
          {
            speakers: [
              {
                name: "L. Marta Turba",
                company: "WorldatWork",
              },
            ],

            description:
              "As HR professionals, we strive to create fair and effective programs, but sometimes our well-intentioned decisions can backfire. In this session, we’ll examine common compensation “habits” that, while designed to benefit employees, may unintentionally harm engagement, equity, and organizational success. With humor and real-world examples, we’ll show how these habits can undermine our goals and provide actionable strategies to course-correct.",
          },
        ],
      },
      {
        time: "10:00 am - 10:15 am",
        title: "Morning Break",
      },
      {
        time: "10:15 am - 11:45 am",
        title: "Performance-Powered Pay: Setting the Bar for Success",
        sessions: [
          {
            speakers: [
              {
                name: "Philippe Asselin",
                company: "BalancedComp",
              },
            ],

            description:
              "In the competitive financial sector, attracting, retaining, and motivating top talent is critical for long-term success. Implementing a well-structured pay-for-performance model can significantly enhance employee engagement, productivity, and overall business outcomes. However, while performance-based compensation offers clear advantages, it also presents potential pitfalls that must be carefully managed.",
          },
        ],
      },
      {
        time: "11:45 am - 12:00 pm",
        title: "Closing Remarks",
      },
    ],
  },
];

export default AgendaData25;
